import { render, staticRenderFns } from "./receiveTx.vue?vue&type=template&id=2110d86a&"
import script from "./receiveTx.vue?vue&type=script&lang=js&"
export * from "./receiveTx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2110d86a')) {
      api.createRecord('2110d86a', component.options)
    } else {
      api.reload('2110d86a', component.options)
    }
    module.hot.accept("./receiveTx.vue?vue&type=template&id=2110d86a&", function () {
      api.rerender('2110d86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/keystore/receiveTx.vue"
export default component.exports